import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { requireAppCheck } from '@jfw/angular/shared/app-check';
import { PLATFORM_DP_ENVIRONMENT } from '@jfw/angular/shared/tokens';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WholesaleRviDocumentService {
  private readonly http = inject(HttpClient);
  private readonly environment = inject(PLATFORM_DP_ENVIRONMENT);
  private readonly rviApiUrl = this.environment.rvi_api_server_url;

  public async getDocumentUrl(
    accountNumber: string,
    filename: string,
  ): Promise<string> {
    const blob = await firstValueFrom(
      this.http.get(
        `${this.rviApiUrl}/document-by-filename-and-account-number/${filename}/${accountNumber}`,
        {
          ...requireAppCheck,
          responseType: 'blob',
        },
      ),
    );
    return URL.createObjectURL(blob);
  }
}
